import LanguageText from '../Contexts/LanguageTextContext'
const LanguageInjector = ({ locale, translations, children }) => {
  let messages = []
  if (!translations) {
    return children
  }
  if (translations) {
    messages = locale ? translations[locale] : translations[0]
  } else {
    const defaultTranslations = {
      en: { i18n_logout: 'Logout' },
      jp: { i18n_logout: 'ログアウト' },
      nl: { i18n_logout: 'Uitloggen' }
    }
    messages = locale ? defaultTranslations[locale] : defaultTranslations[0]
  }
  return (
    <LanguageText.Provider value={messages}>{children}</LanguageText.Provider>
  )
}

export default LanguageInjector
